import { render, staticRenderFns } from "./AddProductModal.vue?vue&type=template&id=b96568c0&scoped=true"
import script from "./AddProductModal.vue?vue&type=script&lang=js"
export * from "./AddProductModal.vue?vue&type=script&lang=js"
import style0 from "./AddProductModal.vue?vue&type=style&index=0&id=b96568c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b96568c0",
  null
  
)

export default component.exports